export function transformTimestampToSeconds(timestamp) {
  return Math.trunc(timestamp / 1000)
}

export function transformTimestampToMilliseconds(timestamp) {
  return Math.trunc(timestamp * 1000)
}
